/****************************************************
 * Module Name:  userMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Drawer, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import FilePresentRounded from "@mui/icons-material/FilePresentRounded";
import UserProxy from "./../../utility/proxy/manager/userProxy";
import AddUsersettingsModalWrapper from "./../settings/addUsersettingsModalWrapper";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import ResetPasswordModal from "../login/resetPassword";
import CommonSnackbar from "../common/commonSnackBar";
import logo from '../../images/pansuriya.jpg'
import DocumentsMaster from "./documentsMaster";
import StockSearchCriteria from "../operations/stockSearchCriteria";
import EditCustomerDetailsModal from "../login/editCustomerDetailsModal";
import { LoadingButton } from "@mui/lab";
import Papa from 'papaparse';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { GetCountries, GetState, GetCity, } from "react-country-state-city";
import UserPermissionProxy from "../../utility/proxy/manager/permissionProxy/userPermissionProxy";
import UserProfileProxy from "../../utility/proxy/manager/userProfileProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import { BackupTable } from "@mui/icons-material";
import { RiFileExcel2Line } from "react-icons/ri";
import PageTitle from "../common/pageTitle";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { BsFillPatchExclamationFill } from "react-icons/bs";

export class UserMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      showAddUserModal: false,

      showUserSettingsModal: false,
      userSettingsUserName: "",

      showResetPasswordModal: false,
      userId: "",
      username: "",

      showDocumentsModal: false,
      userDocumentsUserId: '',
      userKyc: "",

      editOperation: false,
      sourceData: {},

      showSnackbar: false,
      snackbarMessage: "",
      snackbarVariant: "",
      loadingButton: false,

      stockCriteriaStored: "",
      drawerExpanded: false,

      showUserLoadSpinner: true,
      isApplyButtonDisabled: true,

      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
      ),

      selectionModel: [],
      uploadLoader: false,
      editLoader: false,
      applyLoader: false,

      countries: [],
      combinedFilterValues: {},

      titleOptions: Constants.TITLES,

      locationOptions: [],
      userTypeOptions: [],

      addUserRequiredColumns: [
        'USER', 'TITLE', 'FIRST NAME', 'MIDDLE NAME', 'LAST NAME',
        'COMPANY NAME', 'EMAIL', 'PHONE CODE', 'PHONE', 'EMERG CONTACT NAME', 'EMERG PHONE',
        'ADDRESS', 'EMERG ADDRESS', 'CITY', 'STATE', 'COUNTRY', 'USER TYPE', 'LOCATION',
        'PINCODE', 'FAX', 'ADDRESS 2', 'GSTN', 'PAN'
      ],
      editUserRequiredColumns: [
        'USER', 'TITLE', 'FIRST NAME', 'MIDDLE NAME', 'LAST NAME',
        'COMPANY NAME', 'EMAIL', 'PHONE CODE', 'PHONE', 'EMERG CONTACT NAME', 'EMERG PHONE',
        'ADDRESS', 'EMERG ADDRESS', 'CITY', 'STATE', 'COUNTRY',
        'PINCODE', 'FAX', 'ADDRESS 2', 'GSTN', 'PAN'
      ]
    };
  }

  componentDidMount() {
    this.fetchLocationData();
    this.fetchUserType();
    this.fetchUserData(false);
    this.initializeLocationData();
    PageTitle("MASTER_USER");
  }

  fetchLocationData = () => {
    LocationProxy.GetAllLocationDetail((response) => {
      if (response) {
        let locationopt = [];
        response.forEach((data) => {
          let iOption = { value: data.id, label: data.name };
          locationopt.push(iOption);
        });

        this.setState({
          locationOptions: locationopt,
        });
      }
    });
  };

  fetchUserType = () => {

    let optionsArray = [];
    Object.keys(Constants.USER_TYPE).forEach((key) => {
      let option = { value: key, label: Constants.USER_TYPE[key] };
      optionsArray.push(option);
    });

    this.setState({
      userTypeOptions: optionsArray,
    });
  };

  initializeLocationData = async () => {
    try {
      const countries = await GetCountries();
      this.setState({ countries });
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };

  handleKycUpdate = (newKyc) => {
    this.setState({ userKyc: newKyc });
    this.fetchUserData(true);
  }

  fetchUserData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showUserLoadSpinner: true, isApplyButtonDisabled: true, selectionModel: [] });

    UserProxy.GetAllUserDetail(
      this.state.local_Permission.length > 0 ? -1 : Constants.loggedInUser.id,
      (responseData) => {
        if (responseData) {
          const transformedData = responseData.map(item => ({
            ...item,
            usertype1: Constants.USER_TYPE[item.usertype],
          }));
          const uniqueFilterValues = {
            designation: Utility.getDistinctOptions(transformedData, "designation"),
            usertype: Utility.getDistinctOptions(transformedData, "usertype1"),
            grade: Utility.getDistinctOptions(transformedData, "grade"),
            location: Utility.getDistinctOptions(transformedData, "location"),
            locationcountry: Utility.getDistinctOptions(transformedData, "locationcountry"),
            city: Utility.getDistinctOptions(transformedData, "city"),
            state: Utility.getDistinctOptions(transformedData, "state"),
            country: Utility.getDistinctOptions(transformedData, "country"),
            title: Utility.getDistinctOptions(transformedData, "title"),
            companyname: Utility.getDistinctOptions(transformedData, "companyname"),
          }
          this.setState({ users: transformedData, showUserLoadSpinner: false, combinedFilterValues: uniqueFilterValues })
        } else {
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        }
      }
    );

  };

  setSnackbarState = (show, message, variant) => {
    this.setState({
      showSnackbar: show,
      snackbarMessage: message,
      snackbarVariant: variant,
    })
  }

  initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      width: 100,
    },
    {
      field: "companyname",
      headerName: "COMPANY NAME",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.companyname : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "title",
      headerName: "TITLE",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.title : [],
      filterOperators: Utility.combinedFilters(),
      cellClassName: 'lavenderCell',
    },
    {
      field: "first_name",
      headerName: "FIRST NAME",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "last_name",
      headerName: "LAST NAME",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "phonecode",
      headerName: "PHONE CODE",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "phone",
      headerName: "PHONE",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "email",
      headerName: "EMAIL",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: renderCellExpand,
      disableExport: false,
      cellClassName: 'lavenderCell',
    },
    {
      field: "username",
      headerName: "USER",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand,
    },
    {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.country : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "address",
      headerName: "ADDRESS",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "middle_name",
      headerName: "MIDDLE NAME",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "fax",
      headerName: "FAX",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "address2",
      headerName: "ADDRESS 2",
      headerAlign: "center",
      align: "center",
      width: 85,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "city",
      headerName: "CITY",
      headerAlign: "center",
      align: "center",
      width: 130,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.city : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "state",
      headerName: "STATE",
      headerAlign: "center",
      align: "center",
      width: 130,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.state : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "pincode",
      headerName: "PINCODE",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "emergencycontactname",
      headerName: "EMERG CONTACT NAME",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "emergencyphone",
      headerName: "EMERG PHONE",
      headerAlign: "center",
      align: "center",
      width: 115,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "emergencyaddress",
      headerName: "EMERG ADDRESS",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "gstinno",
      headerName: "GSTN",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "panno",
      headerName: "PAN",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
    },
    {
      field: "designation",
      headerName: "DESIGNATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.designation : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      disableExport: true
    },
    {
      field: "usertype",
      headerName: "USER TYPE",
      headerAlign: "center",
      align: "center",
      width: 90,
      disableExport: true,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.usertype : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
      valueGetter: (params) => Constants.USER_TYPE[params.value],
    },
    {
      field: "grade",
      headerName: "GRADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.grade : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      disableExport: true
    },
    {
      field: "employeeid",
      headerName: "EMPLOYEE ID",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      disableExport: true
    },
    {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
      disableExport: true
    },
    {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.location : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: 'lavenderCell',
      disableExport: true,
    },
    {
      field: "locationcountry",
      headerName: "LOCATION COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: this.state.combinedFilterValues ? this.state.combinedFilterValues.locationcountry : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      disableExport: true
    },
    {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 50,
      disableExport: true
    },
    {
      field: "commission",
      headerName: "COMMISSION",
      headerAlign: "center",
      align: "center",
      width: 95,
      disableExport: true
    },
    {
      field: "documents",
      headerName: "DOCUMENTS",
      headerAlign: "center",
      align: "center",
      export: false,
      width: 90,
      renderCell: (params) => (
        <Box
          style={{ textAlign: "center", cursor: "pointer" }}
          onClick={() =>
            this.setState({
              showDocumentsModal: true,
              userDocumentsUserId: params.row.id,
              userKyc: params.row.kyc
            })
          }
        >
          <FilePresentRounded color="info" />
        </Box>
      ),
      disableExport: true
    },
    {
      field: "kyc",
      headerName: "KYC",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "boolean",
      renderCell: (params) => {
        return (
          <Tooltip title={params.value ? "Approved" : "Pending"}>
            <span
              style={{
                color: params.value ? "green" : "orange",
                cursor: "pointer",
              }}
            >
              {params.value ? <BsFillPatchCheckFill size={19} /> : <BsFillPatchExclamationFill size={19} />}
            </span>
          </Tooltip>
        );
      },
      disableExport: true
    },
    {
      field: "deleted",
      headerName: "DELETED",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Active">
            <Box>
              <PersonIcon color="success" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Inactive">

            <Box>
              <PersonOffIcon color="error" />
            </Box>
          </Tooltip>
        );
      },
      disableExport: true
    },
    {
      field: "disabled",
      headerName: "DISABLED",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Enable">
            <Box>
              <PersonIcon color="success" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Disable">

            <Box>
              <PersonOutlineOutlinedIcon color="error" />
            </Box>
          </Tooltip>
        );
      },
      disableExport: true
    },
    {
      field: "settingdummy",
      headerName: "SETTINGS",
      headerAlign: "center",
      align: "center",
      export: false,
      width: 90,
      renderCell: (params) => (
        <Box
          style={{ textAlign: "center", cursor: "pointer" }}
          onClick={() =>
            this.setState({
              showUserSettingsModal: true,
              userSettingsUserName: params.row.username,
            })
          }
        >
          <ManageAccountsIcon color="warning" fontSize="medium" />
        </Box>
      ),
      disableExport: true
    },
    {
      field: "viewsearchcriteria",
      headerName: "SEARCH CRITERIA",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() =>
              this.setState({
                drawerExpanded: !this.state.drawerExpanded,
              })
            }
          >
            View
          </Button>
        </Box>
      ),
      disableExport: true
    },
    {
      field: "resetpassword",
      headerName: "RESET PASSWORD",
      headerAlign: "center",
      align: "center",
      export: false,
      width: 140,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() =>
              this.setState({
                showResetPasswordModal: true,
                username: params.row.username,
                userId: params.row.id,
                loadingButton: false,
              })
            }
          >
            Reset
          </Button>
        </Box>
      ),
      disableExport: true
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      export: false,
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: (this.state.local_Permission.length > 1 || Constants.loggedInUser.usertype === "E") ? "pointer" : "not-allowed" }}
            onClick={() => {
              this.setState({
                showAddUserModal: true,
                editOperation: true,
                sourceData: params.row,
                loadingButton: false,
              });
            }}
          >
            <BorderColorIcon
              color={this.state.local_Permission.length > 1 || Constants.loggedInUser.usertype === "E" ? "primary" : "disabled"}
            />
          </Box >
        );
      },
      disableExport: true
    },
  ];

  hideAddUserModal = () => {
    this.setState({
      showAddUserModal: false,
    });
  };

  hideResetPasswordModal = () => {
    this.setState({
      showResetPasswordModal: false,
    });
  };

  handleValidation = (userData) => {
    //TODO do validation if needed here
    return true;
  };

  addUser = (userData, stoneType, initialStoneType, profilephoto) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Update existing User, and once user is updated on call refresh the list of current users
      UserProxy.UpdateUserAndProfileDetails([userData], (response) => {
        if (response) {
          this.handlePermission(userData.id, stoneType, initialStoneType);
          this.fetchUserData(true);

          this.setSnackbarState(true, "Updated profile successfully !!", "success");
          this.hideAddUserModal();

          this.setState({
            loadingButton: false,
          });
        } else {
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");

          this.setState({
            loadingButton: false,
          });
        }
      });
    } else {
      //Creating new User, and once user is created on call refresh the list of current users
      UserProxy.AddUserAndProfileDetails(userData, (response) => {
        if (response) {
          this.handlePermission(response.id, stoneType, initialStoneType);
          this.fetchUserData(true);
          this.uploadProfilePicture(response.id, profilephoto);
          this.setSnackbarState(true, "User added successfully !!", "success");

          this.setState({
            loadingButton: false,
          });

          this.hideAddUserModal();
        } else {
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");

          this.setState({
            loadingButton: false,
          });
        }
      });
    }
  };

  uploadProfilePicture = (userId, profilephoto) => {
    let profileData = new FormData();
    profileData.append("file", profilephoto);

    UserProfileProxy.AddProfilePhoto(
      userId,
      profileData,
      (response) => { }
    );
  }

  handlePermission = (userId, stoneType, initialStoneType) => {
    const { permissionsToRemove, permissionsToAdd } = Utility.getPermissionsChange(initialStoneType, stoneType);

    if (permissionsToRemove.length > 0) {
      let data = permissionsToRemove.flatMap(permissionId => [
        { userid: userId, permissionid: permissionId, type: 'READ' },
        { userid: userId, permissionid: permissionId, type: 'UPDATE' },
        { userid: userId, permissionid: permissionId, type: 'DELETE' },
        { userid: userId, permissionid: permissionId, type: 'ADD' },
      ]);

      UserPermissionProxy.DeleteUserPermission(data, (response) => {
        if (response) {
        } else {
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");

          this.setState({
            loadingButton: false,
          });
        }
      });
    }

    if (permissionsToAdd.length > 0) {
      const data = permissionsToAdd.flatMap(permissionId => [
        { userid: userId, permissionid: permissionId, type: 'READ' },
        { userid: userId, permissionid: permissionId, type: 'UPDATE' },
        { userid: userId, permissionid: permissionId, type: 'DELETE' },
        { userid: userId, permissionid: permissionId, type: 'ADD' },
      ]);

      UserPermissionProxy.AddUserPermission(data, (response) => {
        if (response) {
        } else {
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");

          this.setState({
            loadingButton: false,
          });
        }
      });
    }
  }

  resetPassword = (username, password) => {
    this.setState({ loadingButton: true });
    UserProxy.ResetPassword(username, password, (response) => {
      if (response) {
        this.hideResetPasswordModal();

        this.setSnackbarState(true, "Password reset successfully !!", "success");

        this.setState({
          loadingButton: false,
        });
      } else {

        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");

        this.setState({
          loadingButton: false,
        });
      }
    });
  };

  // kept this function diffrently as it wont be necessary for edit user functionality 
  validateLocationAndUserType = async (record, isValid) => {
    let userType = record['USER TYPE'].trim().toLowerCase();
    let matchedUserType = this.state.userTypeOptions.find(opt => opt.label.toLowerCase() === userType);
    if (userType !== "" && userType.length !== 0 && matchedUserType) {

      userType = matchedUserType.value;

      let companyLocation = record['LOCATION'].replace(/\s+/g, "").toLowerCase();
      let matchedlocation = this.state.locationOptions.find(opt => opt.label.toLowerCase() === companyLocation);

      if (companyLocation !== "" && companyLocation.length !== 0 && matchedlocation) {
        companyLocation = matchedlocation.value;

        if (isValid) {
          return {
            locationid: companyLocation,
            usertype: userType
          }
        }

      } else {

        this.setSnackbarState(true, `Location is empty or invalid for user: ${record['USER']}`, "warning");

        this.setState({
          uploadLoader: false,
          showUserLoadSpinner: false,
        });

        isValid = false;
        return;
      }
    } else {
      this.setSnackbarState(true, `User Type is empty or invalid for user: ${record['USER']}`, "warning");

      this.setState({
        uploadLoader: false,
        showUserLoadSpinner: false,
      });
      isValid = false;
      return;
    }
  }

  validateFields = async (idx, record, isValid) => {
    let validUserCountryName = "";
    let validUserPhoneCode = "";
    let validUserStateName = "";
    let validUserCityName = "";

    let username = record['USER'].trim();
    if (username !== "" && username.length !== 0) {

      let usertitle = record['TITLE'].trim().toLowerCase();
      const matchedTitle = this.state.titleOptions.find(opt => opt.label.toLowerCase() === usertitle);

      if (usertitle !== "" && usertitle.length !== 0 && matchedTitle) {

        usertitle = matchedTitle.value;

        let userFirstName = record['FIRST NAME'].trim();

        if (userFirstName !== "" && userFirstName.length !== 0) {

          let userLastName = record['LAST NAME'].trim();
          if (userLastName !== "" && userLastName.length !== 0) {

            let userCompanyName = record['COMPANY NAME'].trim();
            if (userCompanyName !== "" && userCompanyName.length !== 0) {

              let userPhoneNo = record['PHONE'].trim();
              if (userPhoneNo !== "" && userPhoneNo.length !== 0 && !isNaN(userPhoneNo)) {

                let userEmailId = record['EMAIL'].trim();
                if (userEmailId !== "" && userEmailId.length !== 0 && Utility.CheckIsEmail(userEmailId)) {

                  let customerCountry = record['COUNTRY'].trim();
                  if (customerCountry !== "" && customerCountry.length !== 0) {

                    const country = this.state.countries.find(
                      (c) => c.name.toLowerCase() === customerCountry.toLowerCase()
                    );

                    if (country) {
                      validUserCountryName = country.name;

                      //phonecode processing
                      let phonecode = record['PHONE CODE'].trim().replace("+", "");

                      //if the phone code insert in the excel is blank or is similar to the country's code 
                      if (phonecode === "" || phonecode === String(country.phone_code)) {
                        validUserPhoneCode = String(country.phone_code);
                      } else {
                        //need to find the code is valid or not  
                        const country1 = this.state.countries.find(
                          (c) => String(c.phone_code) === phonecode
                        );

                        // if the phonecode inserted doesnt exists for any country then need to show warning
                        if (country1) {
                          validUserPhoneCode = String(country1.phone_code)
                        } else {
                          this.setSnackbarState(true, `Phone code : ${phonecode} is invalid for ${record['USER']}`, "warning");

                          this.setState({
                            uploadLoader: false,
                            showUserLoadSpinner: false,
                          });
                          isValid = false; // Stop further processing on error
                          return;
                        }
                      }

                      let customerState = record['STATE'].trim();
                      if (customerState !== "" && customerState.length !== 0) {
                        try {
                          const states = await GetState(country.id);
                          const state = states.find((s) => s.name.toLowerCase() === customerState.toLowerCase());
                          if (state) {
                            validUserStateName = state.name;

                            let customerCity = record['CITY'].trim();

                            if (customerCity !== "" && customerCity.length !== 0) {
                              try {
                                const cities = await GetCity(country.id, state.id);
                                const city = cities.find((c) => c.name.toLowerCase() === customerCity.toLowerCase());

                                if (city) {
                                  validUserCityName = city.name;
                                } else {

                                  this.setSnackbarState(true, `City name -${customerCity} is invalid for user: ${record['USER']}`, "warning");

                                  this.setState({
                                    uploadLoader: false,
                                    showUserLoadSpinner: false,
                                  });
                                  isValid = false; // Stop further processing on error
                                  return;
                                }
                              } catch (error) {
                                console.error("Error fetching cities:", error);
                                isValid = false; // Handle errors if needed
                              }
                            }
                          } else {

                            this.setSnackbarState(true, `State name -${customerState} is invalid for user: ${record['USER']}`, "warning");

                            this.setState({
                              uploadLoader: false,
                              showUserLoadSpinner: false,
                            });

                            isValid = false; // Stop further processing on error
                            return;
                          }
                        } catch (error) {
                          console.error("Error fetching states:", error);
                          isValid = false; // Handle errors if needed
                          return;
                        }
                      }

                      if (isValid) {
                        return {

                          email: userEmailId,
                          title: usertitle,
                          first_name: userFirstName,
                          middle_name: record['MIDDLE NAME'] || "",
                          last_name: userLastName,
                          companyname: userCompanyName,
                          phone: userPhoneNo,
                          emergencycontactname: record['EMERG CONTACT NAME'] || "",
                          emergencyphone: record['EMERG PHONE'] || "",
                          address: record['ADDRESS'] || "",
                          emergencyaddress: record['EMERG ADDRESS'] || "",
                          city: validUserCityName,
                          state: validUserStateName,
                          country: validUserCountryName,
                          pincode: record['PINCODE'] || "",
                          fax: record['FAX'] || "",
                          address2: record['ADDRESS 2'] || "",
                          phonecode: validUserPhoneCode,
                          gstinno: record['GSTN'] || "",
                          panno: record['PAN'] || "",
                        };
                      }
                    } else {
                      this.setSnackbarState(true, `Country name -${customerCountry} is invalid for user: ${record['USER']}`, "warning");

                      this.setState({
                        uploadLoader: false,
                        showUserLoadSpinner: false,
                      });
                      isValid = false; // Stop further processing on error
                      return;
                    }
                  } else {
                    this.setSnackbarState(true, `Country name is empty for user: ${record['USER']}`, "warning");

                    this.setState({
                      uploadLoader: false,
                      showUserLoadSpinner: false,
                    });
                    isValid = false; // Stop further processing on error
                    return;
                  }
                } else {
                  this.setSnackbarState(true, `Email is empty or invalid for user: ${record['USER']}`, "warning");

                  this.setState({
                    uploadLoader: false,
                    showUserLoadSpinner: false,
                  });
                  isValid = false; // Stop further processing on error
                  return;
                }
              } else {
                this.setSnackbarState(true, `Phone No is empty or invalid for user: ${record['USER']}`, "warning");

                this.setState({
                  uploadLoader: false,
                  showUserLoadSpinner: false,
                });
                isValid = false; // Stop further processing on error
                return;
              }
            } else {

              this.setSnackbarState(true, `Company name is empty for user: ${record['USER']}`, "warning");

              this.setState({
                uploadLoader: false,
                showUserLoadSpinner: false,
              });
              isValid = false; // Stop further processing on error
              return;
            }
          } else {
            this.setSnackbarState(true, `Last name is empty for user: ${record['USER']}`, "warning");

            this.setState({
              uploadLoader: false,
              showUserLoadSpinner: false,
            });
            isValid = false; // Stop further processing on error
            return;
          }
        } else {

          this.setSnackbarState(true, `First name is empty for user: ${record['USER']}`, "warning");

          this.setState({
            uploadLoader: false,
            showUserLoadSpinner: false,
          });
          isValid = false; // Stop further processing on error
          return;
        }
      } else {
        this.setSnackbarState(true, `Title is empty or invalid for user: ${record['USER']}`, "warning");

        this.setState({
          uploadLoader: false,
          showUserLoadSpinner: false,
        });
        isValid = false; // Stop further processing on error
        return;
      }
    } else {
      this.setSnackbarState(true, `Username is empty for record no: ${idx + 2}`, "warning");

      this.setState({
        uploadLoader: false,
        showUserLoadSpinner: false,
      });
      isValid = false; // Stop further processing on error
      return;
    }
  }

  // add user through excel
  handleAddUpload = (file) => {

    const reader = new FileReader();

    reader.onload = () => {
      const text = reader.result;

      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {

          if (result.data.length <= 0) {
            this.setSnackbarState(true, "No Users Found", "error");

            this.setState({
              uploadLoader: false,
              showUserLoadSpinner: false,
            });
            return;
          }

          let headersFromCSV = Object.keys(result.data[0]);
          if (this.state.addUserRequiredColumns.length === headersFromCSV.length) {

            let matchedList = [];
            let isValid = true;
            const processRecords = async () => {

              for (let i = 0; i < result.data.length && isValid; i++) {
                const record = result.data[i];

                let row = await this.validateFields(i, record, isValid); // remaining fields

                let row1 = await this.validateLocationAndUserType(record, isValid); // userType and location validated

                if (row && row1) { // both are necessary
                  row = {
                    ...row,
                    ...row1,
                    createdby: Constants.loggedInUser.username,
                    username: record['USER'].trim(),

                    //default values
                    disabled: false,
                    deleted: false,
                    specialuser: false,
                    commission: 0,
                    discount: 0,
                    grade: 'B',
                  }
                  matchedList.push(row);
                } else {
                  break;
                }
              }
            };

            processRecords().then(() => {
              //only if the mandatory fields are validated then 
              if (result.data.length === matchedList.length) {
                this.handleAddUserByExcel(matchedList);
              } else {
                this.setState({
                  uploadLoader: false,
                  showUserLoadSpinner: false,
                });
              }
            });

          } else {
            console.error('CSV columns do not match table columns.');

            this.setSnackbarState(true, "CSV columns do not match table columns.", "error");

            this.setState({
              uploadLoader: false,
              showUserLoadSpinner: false,
            });
          }
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);

          this.setSnackbarState(true, "Something went wrong. Please try again after sometime.", "error");

          this.setState({
            uploadLoader: false,
            showUserLoadSpinner: false,
          });
        }
      });
    };

    reader.readAsText(file);
  };

  // edit user through excel
  handleEditUpload = (file) => {
    const reader = new FileReader();

    reader.onload = () => {
      const text = reader.result;

      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          if (result.data.length <= 0) {
            this.setSnackbarState(true, "No Users Found", "error");

            this.setState({
              editLoader: false,
              showUserLoadSpinner: false,
            });
            return;
          }

          let headersFromCSV = Object.keys(result.data[0]);

          if (this.state.editUserRequiredColumns.length === headersFromCSV.length) {

            let matchedList = [];
            let unmatchedList = [];
            const selectionData = new Set();
            let isValid = true;
            const processRecords = async () => {

              for (let i = 0; i < result.data.length && isValid; i++) {
                const record = result.data[i];
                let usernameValid = false;
                // Loop through the existing users
                for (let j = 0; j < this.state.users.length && isValid; j++) {

                  const row = this.state.users[j];
                  if (row.username === record['USER']) {
                    usernameValid = true;

                    let updatedrow = await this.validateFields(i, record, isValid);

                    if (updatedrow) {

                      let newrow = {
                        ...row,
                        ...updatedrow,
                      }
                      matchedList.push(newrow);
                      selectionData.add(newrow.id);
                    }
                  }
                }

                if (!usernameValid) {
                  this.setSnackbarState(true, `Username -${record['USER']} is invalid on line no ${i + 2}`, "warning");
                  this.setState({
                    editLoader: false,
                    showUserLoadSpinner: false,
                  });
                  isValid = false; // Stop further processing on error
                  break;
                }
              }
            };

            processRecords().then(() => {

              if (result.data.length === matchedList.length) {
                this.state.users.forEach(iRow => {
                  if (!selectionData.has(iRow.id)) {
                    unmatchedList.push(iRow);
                  }
                });
                this.setState({
                  selectionModel: Array.from(selectionData),
                  users: matchedList.concat(unmatchedList),
                  editLoader: false,
                  showUserLoadSpinner: false,
                  isApplyButtonDisabled: false,
                });

              } else {
                this.setState({
                  editLoader: false,
                  showUserLoadSpinner: false,
                });
              }
            });
          } else {
            console.error('CSV columns do not match table columns.');
            this.setSnackbarState(true, "CSV columns do not match table columns.", "error");
            this.setState({
              editLoader: false,
              showUserLoadSpinner: false,
            });
          }
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
          this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
          this.setState({
            editLoader: false,
            showUserLoadSpinner: false,
          });
        }
      });
    };

    reader.readAsText(file);
  };

  handleAddUserByExcel = (data) => {

    UserProxy.AddUserAndProfileDetailsByExcel(data, (response) => {
      if (response) {

        this.setSnackbarState(true, response.errorMessage, response.status);
        this.setState({
          selectionModel: [],
          applyLoader: false,
          showUserLoadSpinner: false,
          uploadLoader: false,
        });
        this.fetchUserData(true);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          applyLoader: false,
          showUserLoadSpinner: false,
          uploadLoader: false,
        });
      }
    })
  }

  handleEditUserByExcel = () => {
    this.setState({ applyLoader: true });
    let data = [];

    this.state.selectionModel.forEach((id) => {
      this.state.users.forEach(iUser => {
        if (iUser.id === id) {
          data.push(iUser);
        }
      })
    })

    UserProxy.UpdateUserAndProfileDetailsByExcel(data, (response) => {
      if (response) {

        this.setSnackbarState(true, response.errorMessage, response.status);

        this.setState({
          selectionModel: [],
          applyLoader: false,
          isApplyButtonDisabled: true,
        });
        this.fetchUserData(true);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          applyLoader: false,
          isApplyButtonDisabled: true,
        });
      }
    })
  }

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
          {this.state.showUserLoadSpinner ? (
            <CircularProgress size="1rem" sx={{ lineHeight: -2 }} />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchUserData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Download Sample User Upload">
              <a
                href="/demo_excel/SampleCreateUserUpload.csv"
                download="SampleCreateUserUpload.csv"
                style={{ color: "red", marginRight: "10px", marginLeft: "10px" }}
              >
                <BackupTable size={25} />
              </a>
            </Tooltip>
          ) : null}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add user">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "7px", mr: "7px" }}
                onClick={() =>
                  this.setState({
                    showAddUserModal: true,
                    editOperation: false,
                    sourceData: {},
                    loadingButton: false,
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                User
              </Button>
            </Tooltip>
          ) : null}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add User Details">
              <Box sx={{
                "& .Mui-disabled": {
                  backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                  color: "rgba(0, 0, 0, 0.26) !important"
                }
              }}>
                <LoadingButton
                  color="error"
                  variant="outlined"
                  size="small"
                  sx={{ ml: "3px" }}
                  component="label"
                  loading={this.state.uploadLoader}
                  loadingPosition="start"
                  startIcon={<RiFileExcel2Line size={25} color="red" />}
                  disabled={this.state.showUserLoadSpinner}
                >
                  Add
                  <input
                    id="file-input"
                    hidden
                    accept=".csv"
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        this.setState({ uploadLoader: true, showUserLoadSpinner: true });
                        this.handleAddUpload(file);
                      }
                    }}
                    onClick={(e) => {
                      e.target.value = "";
                    }}
                  />
                </LoadingButton>
              </Box>
            </Tooltip>
          ) : null}

          {Constants.loggedInUser.usertype === "E" ? (
            <Tooltip title="Edit User Details">
              <Box sx={{
                "& .Mui-disabled": {
                  backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                  color: "rgba(0, 0, 0, 0.26) !important"
                }
              }}>
                <LoadingButton
                  color="success"
                  variant="outlined"
                  size="small"
                  sx={{ ml: "3px" }}
                  component="label"
                  loading={this.state.editLoader}
                  loadingPosition="start"
                  startIcon={<RiFileExcel2Line size={25} color="success" />}
                  disabled={this.state.showUserLoadSpinner}
                >
                  Edit
                  <input
                    id="file-input"
                    hidden
                    accept=".csv"
                    type="file"
                    onChange={(e) => {

                      const file = e.target.files[0];
                      if (file) {
                        this.setState({ editLoader: true, showUserLoadSpinner: true });
                        this.handleEditUpload(file);
                      }
                    }}
                    onClick={(e) => {
                      e.target.value = ""
                    }}
                  />
                </LoadingButton>
              </Box>
            </Tooltip>
          ) : null}

          {Constants.loggedInUser.usertype === "E" ? (
            <LoadingButton
              color="success"
              variant="contained"
              size="small"
              sx={{ ml: "7px" }}
              onClick={() => this.handleEditUserByExcel()}
              disabled={this.state.selectionModel.length === 0 || this.state.isApplyButtonDisabled}
              loading={this.state.applyLoader}
              loadingPosition="start"
              startIcon={<TaskAltIcon size="large" />}
            >
              Apply
            </LoadingButton>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    const rows = this.state.users;
    const columns = (Utility.isUpdateAllowed(this.state.local_Permission)) || Constants.loggedInUser.usertype === 'E'
      ? this.initialColumns()
      : this.initialColumns().filter(
        (col) => col.field !== "edit" && col.field !== "resetpassword"
      );
    return (
      <Box>
        <Drawer
          anchor="left"
          open={this.state.drawerExpanded}
          style={{ width: "50%" }}
          onClose={() => this.setState({ drawerExpanded: false })}>
          <StockSearchCriteria
            displaySearchCriteria={false}
            stockCriteriaStored={this.state.stockCriteriaStored}
            handleSearch={() => { }}
            showSaveSearchAs={true}
            readOnly={true}
            setCustomerId={(data) => { }}
            setFilters={(data) => { }}
            drawerClose={() => this.setState({ drawerExpanded: false })}
            enableReportNoSearchBox={false}
          />
        </Drawer>
        <br />
        {this.state.showDocumentsModal ? (
          <DocumentsMaster
            logo={logo}
            Show={true}
            userId={this.state.userDocumentsUserId}
            kyc={this.state.userKyc}
            onKycUpdate={this.handleKycUpdate}
            handleClose={() => {
              this.setState({ showDocumentsModal: false })
            }}
          />
        ) : null}

        {this.state.showUserSettingsModal ? (
          <AddUsersettingsModalWrapper
            logo={logo}
            Show={true}
            loadData={true}
            username={this.state.userSettingsUserName}
            handleClose={() =>
              this.setState({
                showUserSettingsModal: false,
                userSettingsUserName: "",
              })
            }
          />
        ) : (
          <Box />
        )}

        <CommonSnackbar
          show={this.state.showSnackbar}
          message={<Box>{this.state.snackbarMessage}</Box>}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ showSnackbar: false })}
          title={this.state.snackbarVariant === "error" ? "Error" :
            this.state.snackbarVariant === "success" ? "Success" :
              (this.state.snackbarVariant === "warning" ? "Warning" : "Failed")
          }
        />

        {this.state.showAddUserModal ? (
          <EditCustomerDetailsModal
            Show={true}
            handleClose={this.hideAddUserModal}
            handleSave={this.addUser}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
            saveButton={true}
            permission={this.state.local_Permission}
          />
        ) : (
          <Box />
        )}

        {this.state.showResetPasswordModal ? (
          <ResetPasswordModal
            Show={true}
            handleClose={this.hideResetPasswordModal}
            handleSave={this.resetPassword}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            userid={this.state.userId}
            username={this.state.username}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "100%",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: "83vh",
            "& .lavenderCell": {
              color: "#080808",
              backgroundColor: "#D8BFD8",
            },
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={true}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "4px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "12px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "18px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
            }}
            slots={{
              toolbar: CustomToolbar,
            }}
            rows={rows}
            density="compact"
            columns={columns}
            getRowId={(row) => row.id}
            loading={this.state.showUserLoadSpinner}
            checkboxSelection={true}
            onRowSelectionModelChange={(newSelectionModel) => {
              this.setState({ selectionModel: newSelectionModel });
            }}
            rowSelectionModel={this.state.selectionModel}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns status and traderName, the other columns will remain visible
                  id: false,
                  locationid: false,
                  locationcountry: false,
                },
              },
              pinnedColumns: { right: ['edit'] },
              pagination: {
                paginationModel: Constants.pageSize,
              },
            }}
            pageSizeOptions={Constants.pageSizeOptions}
            pagination
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
      </Box>
    );
  }
}

export default UserMaster;
